import Icon from '@ant-design/icons';

const Svg = () => (
  <svg viewBox='0 0 18 18' width='1em' height='1em' fill='currentColor'>
    <path d='M14 0H4C2.9 0 2 0.9 2 2V16C2 17.1 2.9 18 4 18H14C15.1 18 16 17.1 16 16V2C16 0.9 15.1 0 14 0ZM14 16H4V2H14V16Z' />
    <path d='M6 5H12V7H6V5Z' />
    <path d='M6 9H12V11H6V9Z' />
    <path d='M6 13H10V15H6V13Z' />
  </svg>
);

export const CalculationStepIcon = (props) => {
  return (
    <Icon component={Svg} {...props} />
  );
};
